import styled from 'styled-components'

export const StyledFormInput = styled.input`
    color: ${props => props.theme.main.colors.inputColor};
    font-size: 14px;
    margin-right: 4px;
    padding: 12px;
    width: auto !important;
    
   
`

export const StyledRadioInput = styled.label`
    align-items: center;
    display: flex;
    padding-right: 20px;
    
    .text-container {
      display: flex;
      flex-direction: column;
      margin-left: 15px;
      
      span {
        margin-bottom: 10px;
        
        :last-child {
          margin-bottom: 0;
        }
       
        .item-container {
          display: flex;
          align-items: center;
          .free {
          
          color: #d43540;
         }
          .free-cost {
            text-decoration: line-through;
          }
          span {
            margin: 0;
          }
        }
      }
    }
`

export const StyledError = styled.span`
    color: ${props => props.theme.main.colors.errorColor};
    font-size: 13px;
`
